import {reduxStore} from '../ReduxIndex';

export function setRightBasketModal(rightBasketModal) {
    reduxStore.dispatch({
        type: 'setRightBasketModal',
        payload: {
            rightBasketModal,
        },
    });
}

export function setBasketList(basketList = []) {
    reduxStore.dispatch({
        type: 'setBasketList',
        payload: {
            basketList,
        },
    });
}



